module.exports = __webpack_public_path__ + "img/warn_12.e21f115c.png";